window.accordionHandler = () => {
  document.addEventListener('DOMContentLoaded', () => {
    collapseAccordion();
  })

  const collapseAccordion = () => {
    const containers = document.querySelectorAll('.jsAccordionContainer');


    containers && containers.forEach(container => {
      const accordion = container.querySelector('.jsAccordion');
      const buttonCollapse = accordion.querySelector('.jsAccordionButtonCollapse');
      const buttonCollapseText = accordion.querySelector('.jsAccordionButtonCollapseText');
      const collapseContainer = accordion.querySelector('.jsAccordionCollapse');

      buttonCollapse.addEventListener('click', () => {
        const collapsed = accordion.getAttribute('data-collapsed');

        if (collapsed === 'true') {
          buttonCollapseText.innerText = 'Click to close';
          accordion.setAttribute('data-collapsed', 'false');
          slideDown(collapseContainer);
        } else {
          buttonCollapseText.innerText = 'Click to expand';
          accordion.setAttribute('data-collapsed', 'true');
          slideUp(collapseContainer);
        }
      });
    });
  };
};
